<a class="skip-anchor" href="#main-content">Skip to main content</a>
<app-fs-header></app-fs-header>
<app-navbar
  (toggledSidenav)="onToggledSidenav($event)"
  [location]="location"
></app-navbar>
<app-sidenav
  (selectedNavItem)="onSelectedNavItem($event)"
  [expanded]="showingSidenav"
></app-sidenav>
<main class="viewport" id="main-content">
  <router-outlet></router-outlet>
  <app-toast></app-toast>
</main>
